import { EleicaoForm, EleicaoTermos } from '../components';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { useAuthAxios, useErrorHandler, useErrorStatus, useLayout } from '../hooks';

import { ApiHelper } from '../helpers';
import { EleicaoResponseType } from '../types';
import { LayoutEnum } from '../enums';
import { Spinner } from '../utils';
import { StatusCodes } from 'http-status-codes';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const EleicaoFormView: FunctionComponent = () => {
  const [termosAceitos, setTermosAceitos] = useState(false);
  const [eleicao, setEleicao] = useState<EleicaoResponseType>();
  const [loadingEleicao, setLoadingEleicao] = useState(true);
  const { t } = useTranslation();
  let { idEleicao } = useParams();
  const axios = useAuthAxios();
  const errorHandler = useErrorHandler();
  const { setErrorStatus } = useErrorStatus();
  const { setLayout } = useLayout();

  useEffect(() => {
    setLayout(LayoutEnum.BASE_LAYOUT);

    if (idEleicao) {
      if (ApiHelper.isValidIntegerToApi(idEleicao)) {
        axios
          .get(ApiHelper.getUrl.apiSCE.eleicao(+idEleicao))
          .then((response) => setEleicao(response.data))
          .catch((error) => {
            if (error.response.status === StatusCodes.NOT_FOUND) {
              setErrorStatus(error.response.status);
            } else {
              errorHandler(error, t('erro.recuperar_eleicao'));
            }
          })
          .finally(() => {
            setTermosAceitos(true);
            setLoadingEleicao(false);
          });
      } else {
        setTimeout(() => {
          setErrorStatus(StatusCodes.NOT_FOUND);
        });
      }
    } else {
      setLoadingEleicao(false);
    }
  }, []);

  return loadingEleicao ? (
    <Spinner />
  ) : termosAceitos ? (
    <EleicaoForm eleicao={eleicao} />
  ) : (
    <EleicaoTermos termosAceitos={termosAceitos} setTermosAceitos={setTermosAceitos} />
  );
};

export default EleicaoFormView;
